module.exports = __webpack_public_path__ + "img/current.49293da9.png";